<blockquote class="s__quote-block">
  <p class="s__quote-block__text" [innerHTML]="quote()"></p>
  <footer class="s__quote-block__footer">
    @if (imageSrc()) {
      <img
        class="s__quote-block__image"
        [ngSrc]="imageSrc()!"
        [width]="imageWidth() || 300"
        [height]="imageHeight() || 300"
        [alt]="imageAlt() || name()"
        sizes="(min-width: 768px) 25vw, 100vw"
      />
    }
    <div class="s__quote-block__attribution">
      <cite class="s__quote-block__name">{{ name() }}</cite>
      <span class="s__quote-block__role">{{ role() }}@if (company()) {, {{ company() }}}</span>
    </div>
  </footer>
</blockquote>
